// import React, { useState, useEffect } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faUser,
//   faEnvelope,
//   faPhone,
//   faBriefcase,
//   faCalendarAlt,
//   faKey,
//   faLock,
//   faSave,
//   faTimes,
//   faFileUpload,
//   faFilePdf,
//   faFileImage,
//   faFileWord,
//   faDownload,
//   faIdCard,
// } from "@fortawesome/free-solid-svg-icons";
// import Layout from "../Layout";
// import { format } from "date-fns";
// import "./ResetPassword.css";

// const BASE_URL = process.env.REACT_APP_BASE_URL;

// const EmployeePasswordReset = () => {
//   const [employee, setEmployee] = useState(null);
//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [isResetting, setIsResetting] = useState(false);
//   const [passwordData, setPasswordData] = useState({
//     newPassword: "",
//     confirmPassword: "",
//   });
//   const [passwordError, setPasswordError] = useState("");
//   const [successMessage, setSuccessMessage] = useState("");
//   const [documents, setDocuments] = useState(null);
//   const [uploading, setUploading] = useState(false);
//   const [documentFiles, setDocumentFiles] = useState({
//     profilePicture: null, // Add this
//     idcard_pic: null, // Add ID card picture
//     panCard: null,
//     aadharCard: null,
//     latestDegree: null,
//     drivingLicense: null,
//     previousCompanyLetter: null,
//     offerLetter: null,
//   });
//   const [documentError, setDocumentError] = useState("");
//   const [documentSuccess, setDocumentSuccess] = useState("");

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const token = sessionStorage.getItem("token");

//         // Fetch employee details
//         const employeeResponse = await fetch(
//           `${BASE_URL}/api/employees/logineduser/myprofile`,
//           {
//             method: "GET",
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );

//         if (!employeeResponse.ok) {
//           throw new Error("Error fetching your details");
//         }

//         const employeeData = await employeeResponse.json();
//         setEmployee(employeeData);

//         // Fetch documents
//         const documentsResponse = await fetch(
//           `${BASE_URL}/api/employees/documents/getdocuments`,
//           {
//             method: "GET",
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );

//         if (!documentsResponse.ok) {
//           throw new Error("Error fetching documents");
//         }

//         // In the fetchData function inside useEffect:
//         const documentsData = await documentsResponse.json();
//         setDocuments({
//           panCard: documentsData.documents?.panCard || "",
//           aadharCard: documentsData.documents?.aadharCard || "",
//           latestDegree: documentsData.documents?.latestDegree || "",
//           drivingLicense: documentsData.documents?.drivingLicense || "",
//           previousCompanyLetter:
//             documentsData.documents?.previousCompanyLetter || "",
//           offerLetter: documentsData.documents?.offerLetter || "", // Add this line
//           profilePicture: documentsData.profilePicture || "",
//           idcard_pic: documentsData.idcard_pic || "", // Make sure this matches your backend response
//         });

//         setError(null);
//         setLoading(false);
//       } catch (err) {
//         console.error("Error fetching data:", err);
//         setEmployee(null);
//         setDocuments(null);
//         setError("Error fetching your details");
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, []);

//   const handlePasswordChange = (e) => {
//     const { name, value } = e.target;
//     setPasswordData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const validatePassword = (password) => {
//     const passwordRegex =
//       /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
//     return passwordRegex.test(password);
//   };

//   const handlePasswordReset = async () => {
//     try {
//       // Validate inputs
//       if (!passwordData.newPassword || !passwordData.confirmPassword) {
//         setPasswordError("Both password fields are required");
//         return;
//       }

//       if (passwordData.newPassword !== passwordData.confirmPassword) {
//         setPasswordError("Passwords do not match");
//         return;
//       }

//       if (!validatePassword(passwordData.newPassword)) {
//         setPasswordError(
//           "Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character"
//         );
//         return;
//       }

//       const token = sessionStorage.getItem("token");
//       const response = await fetch(
//         `${BASE_URL}/api/employees/myprofile/reset-password`,
//         {
//           method: "PUT",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             newPassword: passwordData.newPassword,
//             confirmPassword: passwordData.confirmPassword,
//           }),
//         }
//       );

//       const data = await response.json();

//       if (!response.ok) {
//         throw new Error(data.message || "Password reset failed");
//       }

//       setSuccessMessage("Password updated successfully!");
//       setPasswordError("");
//       setPasswordData({
//         newPassword: "",
//         confirmPassword: "",
//       });
//       setIsResetting(false);

//       // Hide success message after 5 seconds
//       setTimeout(() => setSuccessMessage(""), 5000);
//     } catch (error) {
//       console.error("Password reset error:", error);
//       setPasswordError(error.message);
//     }
//   };

//   const handleFileChange = (e, documentType) => {
//     const file = e.target.files[0];
//     if (file) {
//       setDocumentFiles((prev) => ({
//         ...prev,
//         [documentType]: file,
//       }));
//     }
//   };

//   const handleDocumentUpload = async () => {
//     try {
//       const token = sessionStorage.getItem("token");
//       if (!token) {
//         throw new Error("Authentication token missing");
//       }

//       const formData = new FormData();
//       let hasFiles = false;

//       Object.entries(documentFiles).forEach(([key, file]) => {
//         if (file) {
//           if (file.size > 5 * 1024 * 1024) {
//             throw new Error(`${key} file is too large (max 5MB)`);
//           }

//           if (key === "profilePicture" || key === "idcard_pic") {
//             if (!file.type.match("image.*")) {
//               throw new Error(`${key} must be an image (JPEG, PNG)`);
//             }
//           } else {
//             const validTypes = ["application/pdf", "image/jpeg", "image/png"];
//             if (!validTypes.includes(file.type)) {
//               throw new Error(`${key} must be PDF, JPEG, or PNG`);
//             }
//           }

//           formData.append(key, file);
//           hasFiles = true;
//         }
//       });

//       if (!hasFiles) {
//         setDocumentError("Please select at least one document to upload");
//         return;
//       }

//       setUploading(true);
//       setDocumentError("");
//       setDocumentSuccess("");

//       const response = await fetch(
//         `${BASE_URL}/api/employees/myprofile/documents`,
//         {
//           method: "PUT",
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//           body: formData,
//         }
//       );

//       const contentType = response.headers.get("content-type");
//       let responseData;

//       if (contentType && contentType.includes("application/json")) {
//         responseData = await response.json();
//       } else {
//         const text = await response.text();
//         responseData = { message: text || "Unknown error occurred" };
//       }

//       if (!response.ok) {
//         throw new Error(
//           responseData.message ||
//             `Document upload failed with status ${response.status}`
//         );
//       }

//       // Update the documents state with the new URLs
//       setDocuments((prev) => ({
//         ...prev,
//         panCard: responseData.documents?.panCard || prev.panCard,
//         aadharCard: responseData.documents?.aadharCard || prev.aadharCard,
//         latestDegree: responseData.documents?.latestDegree || prev.latestDegree,
//         drivingLicense:
//           responseData.documents?.drivingLicense || prev.drivingLicense,
//         previousCompanyLetter:
//           responseData.documents?.previousCompanyLetter ||
//           prev.previousCompanyLetter,
//         profilePicture: responseData.profilePicture || prev.profilePicture,
//         idcard_pic: responseData.idcard_pic || prev.idcard_pic, // Make sure this matches your backend response
//       }));

//       setDocumentSuccess("Documents uploaded successfully!");
//       setDocumentFiles({
//         profilePicture: null,
//         idcard_pic: null,
//         panCard: null,
//         aadharCard: null,
//         latestDegree: null,
//         drivingLicense: null,
//         previousCompanyLetter: null,
//         offerLetter: null, // Add this line
//       });

//       // Refresh employee data if profile picture or ID card was updated
//       if (documentFiles.profilePicture || documentFiles.idcard_pic) {
//         const employeeResponse = await fetch(
//           `${BASE_URL}/api/employees/logineduser/myprofile`,
//           {
//             method: "GET",
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );

//         if (employeeResponse.ok) {
//           const employeeData = await employeeResponse.json();
//           setEmployee(employeeData);
//         }
//       }
//     } catch (error) {
//       console.error("Document upload error:", error);
//       setDocumentError(
//         error.message || "Failed to upload documents. Please try again."
//       );
//     } finally {
//       setUploading(false);
//       setTimeout(() => {
//         setDocumentError("");
//         setDocumentSuccess("");
//       }, 5000);
//     }
//   };

//   const getFileIcon = (fileName) => {
//     if (!fileName) return faFileImage;
//     const extension = fileName.split(".").pop().toLowerCase();
//     if (["pdf"].includes(extension)) return faFilePdf;
//     if (["doc", "docx"].includes(extension)) return faFileWord;
//     if (["jpg", "jpeg", "png", "gif"].includes(extension)) return faFileImage;
//     return faFileImage;
//   };

//   return (
//     <Layout>
//       <div className="employee-password-reset-container">
//         <div className="password-reset-header">
//           <h2 className="page-title">My Profile</h2>
//         </div>

//         {error && <div className="error-message">{error}</div>}
//         {successMessage && (
//           <div className="success-message">{successMessage}</div>
//         )}
//         {documentSuccess && (
//           <div className="success-message">{documentSuccess}</div>
//         )}

//         {loading && (
//           <div className="loading-container">
//             <div className="spinner"></div>
//             <p>Loading your data...</p>
//           </div>
//         )}

//         {employee && (
//           <div className="employee-profile-section">
//             <div className="profile-header">
//               <div className="avatar">
//                 {documents?.profilePicture ? (
//                   <img
//                     src={documents.profilePicture}
//                     alt="Profile"
//                     className="avatar-image"
//                   />
//                 ) : (
//                   employee.name.charAt(0).toUpperCase()
//                 )}
//               </div>
//               <div className="profile-info">
//                 <h3 className="employee-name">{employee.name}</h3>
//                 <p className="employee-id">
//                   Employee ID: {employee.employeeid}
//                 </p>
//                 <p className="employee-role">
//                   <FontAwesomeIcon icon={faBriefcase} /> {employee.role}
//                 </p>
//               </div>
//             </div>

//             <div className="profile-details-grid">
//               <div className="detail-card">
//                 <h4 className="card-title">
//                   <FontAwesomeIcon icon={faUser} /> Basic Information
//                 </h4>
//                 <div className="detail-item">
//                   <span className="detail-label">Name:</span>
//                   <span className="detail-value">{employee.name}</span>
//                 </div>
//                 <div className="detail-item">
//                   <span className="detail-label">Email:</span>
//                   <span className="detail-value">{employee.email}</span>
//                 </div>
//                 <div className="detail-item">
//                   <span className="detail-label">Contact:</span>
//                   <span className="detail-value">{employee.contactNumber}</span>
//                 </div>
//               </div>

//               <div className="detail-card">
//                 <h4 className="card-title">
//                   <FontAwesomeIcon icon={faBriefcase} /> Employment Details
//                 </h4>
//                 <div className="detail-item">
//                   <span className="detail-label">Date of Joining:</span>
//                   <span className="detail-value">
//                     {format(new Date(employee.dateOfJoining), "dd-MM-yyyy")}
//                   </span>
//                 </div>
//                 <div className="detail-item">
//                   <span className="detail-label">Job Location:</span>
//                   <span className="detail-value">{employee.jobLocation}</span>
//                 </div>
//                 <div className="detail-item">
//                   <span className="detail-label">Work Mode:</span>
//                   <span className="detail-value">{employee.workMode}</span>
//                 </div>
//               </div>
//             </div>

//             {/* Documents Section */}
//             <div className="documents-section">
//               <h3>
//                 <FontAwesomeIcon icon={faFileUpload} /> My Documents
//               </h3>
//               {documentError && (
//                 <div className="error-message">{documentError}</div>
//               )}
//               {documentSuccess && (
//                 <div className="success-message">{documentSuccess}</div>
//               )}

//               {/* Profile Pictures Container */}
//               <div className="profile-pictures-container">
//                 {/* Profile Picture Card */}
//                 <div className="profile-picture-card">
//                   <h4>
//                     <FontAwesomeIcon icon={faUser} /> Profile Picture
//                   </h4>
//                   <div className="profile-picture-container">
//                     {documents?.profilePicture ? (
//                       <div className="profile-picture-preview">
//                         <img
//                           src={documents.profilePicture}
//                           alt="Profile"
//                           className="profile-image"
//                         />
//                         <a
//                           href={documents.profilePicture}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                           className="download-link"
//                         >
//                           <FontAwesomeIcon icon={faDownload} /> View Image
//                         </a>
//                       </div>
//                     ) : (
//                       <div className="profile-picture-placeholder">
//                         <FontAwesomeIcon icon={faUser} size="3x" />
//                         <p>No profile picture uploaded</p>
//                       </div>
//                     )}
//                     <div className="profile-picture-upload">
//                       <input
//                         type="file"
//                         id="profilePicture"
//                         onChange={(e) => handleFileChange(e, "profilePicture")}
//                         accept=".jpg,.jpeg,.png"
//                       />
//                       <label htmlFor="profilePicture" className="upload-button">
//                         <FontAwesomeIcon icon={faFileUpload} />{" "}
//                         {documents?.profilePicture ? "Change" : "Upload"}
//                       </label>
//                       {documentFiles.profilePicture && (
//                         <span className="file-name">
//                           {documentFiles.profilePicture.name}
//                         </span>
//                       )}
//                       <p
//                         style={{
//                           fontSize: "0.85rem",
//                           color: "#888",
//                           marginTop: "4px",
//                         }}
//                       >
//                         Max size: 5 MB | Formats: JPG, JPEG, PNG
//                       </p>
//                     </div>
//                   </div>
//                 </div>

//                 {/* ID Card Picture Card */}
//                 <div className="profile-picture-card">
//                   <h4>
//                     <FontAwesomeIcon icon={faIdCard} /> ID Card Picture
//                   </h4>
//                   <div className="profile-picture-container">
//                     {documents?.idcard_pic ? (
//                       <div className="profile-picture-preview">
//                         <img
//                           src={documents.idcard_pic}
//                           alt="ID Card"
//                           className="profile-image"
//                         />
//                         <a
//                           href={documents.idcard_pic}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                           className="download-link"
//                         >
//                           <FontAwesomeIcon icon={faDownload} /> View Image
//                         </a>
//                       </div>
//                     ) : (
//                       <div className="profile-picture-placeholder">
//                         <FontAwesomeIcon icon={faIdCard} size="3x" />
//                         <p>No ID card picture uploaded</p>
//                       </div>
//                     )}
//                     <div className="profile-picture-upload">
//                       <input
//                         type="file"
//                         id="idcard_pic"
//                         onChange={(e) => handleFileChange(e, "idcard_pic")}
//                         accept=".jpg,.jpeg,.png"
//                       />
//                       <label htmlFor="idcard_pic" className="upload-button">
//                         <FontAwesomeIcon icon={faFileUpload} />{" "}
//                         {documents?.idcard_pic ? "Change" : "Upload"}
//                       </label>
//                       {documentFiles.idcard_pic && (
//                         <span className="file-name">
//                           {documentFiles.idcard_pic.name}
//                         </span>
//                       )}
//                       <p
//                         style={{
//                           fontSize: "0.85rem",
//                           color: "#888",
//                           marginTop: "4px",
//                         }}
//                       >
//                         Max size: 5 MB | Formats: JPG, JPEG, PNG
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Documents Grid */}
//               <div className="document-grid">
//                 {/* PAN Card */}
//                 <div className="document-card">
//                   <h4>PAN Card</h4>
//                   {documents?.panCard ? (
//                     <div className="document-preview">
//                       <FontAwesomeIcon
//                         icon={getFileIcon(documents.panCard)}
//                         size="2x"
//                       />
//                       <a
//                         href={documents.panCard}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className="download-link"
//                       >
//                         <FontAwesomeIcon icon={faDownload} /> View Document
//                       </a>
//                     </div>
//                   ) : (
//                     <p className="no-document">No document uploaded</p>
//                   )}
//                   <div className="document-upload">
//                     <input
//                       type="file"
//                       id="panCard"
//                       onChange={(e) => handleFileChange(e, "panCard")}
//                       accept=".pdf,.jpg,.jpeg,.png"
//                     />
//                     <label htmlFor="panCard" className="upload-button">
//                       <FontAwesomeIcon icon={faFileUpload} />{" "}
//                       {documents?.panCard ? "Replace" : "Upload"}
//                     </label>
//                     {documentFiles.panCard && (
//                       <span className="file-name">
//                         {documentFiles.panCard.name}
//                       </span>
//                     )}
//                     <p
//                       style={{
//                         fontSize: "0.85rem",
//                         color: "#888",
//                         marginTop: "4px",
//                       }}
//                     >
//                       Max size: 5 MB | Formats: PDF, JPG, JPEG, PNG
//                     </p>
//                   </div>
//                 </div>

//                 {/* Aadhar Card */}
//                 <div className="document-card">
//                   <h4>Aadhar Card</h4>
//                   {documents?.aadharCard ? (
//                     <div className="document-preview">
//                       <FontAwesomeIcon
//                         icon={getFileIcon(documents.aadharCard)}
//                         size="2x"
//                       />
//                       <a
//                         href={documents.aadharCard}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className="download-link"
//                       >
//                         <FontAwesomeIcon icon={faDownload} /> View Document
//                       </a>
//                     </div>
//                   ) : (
//                     <p className="no-document">No document uploaded</p>
//                   )}
//                   <div className="document-upload">
//                     <input
//                       type="file"
//                       id="aadharCard"
//                       onChange={(e) => handleFileChange(e, "aadharCard")}
//                       accept=".pdf,.jpg,.jpeg,.png"
//                     />
//                     <label htmlFor="aadharCard" className="upload-button">
//                       <FontAwesomeIcon icon={faFileUpload} />{" "}
//                       {documents?.aadharCard ? "Replace" : "Upload"}
//                     </label>
//                     {documentFiles.aadharCard && (
//                       <span className="file-name">
//                         {documentFiles.aadharCard.name}
//                       </span>
//                     )}
//                     <p
//                       style={{
//                         fontSize: "0.85rem",
//                         color: "#888",
//                         marginTop: "4px",
//                       }}
//                     >
//                       Max size: 5 MB | Formats: PDF, JPG, JPEG, PNG
//                     </p>
//                   </div>
//                 </div>

//                 {/* Latest Degree */}
//                 <div className="document-card">
//                   <h4>Latest Degree</h4>
//                   {documents?.latestDegree ? (
//                     <div className="document-preview">
//                       <FontAwesomeIcon
//                         icon={getFileIcon(documents.latestDegree)}
//                         size="2x"
//                       />
//                       <a
//                         href={documents.latestDegree}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className="download-link"
//                       >
//                         <FontAwesomeIcon icon={faDownload} /> View Document
//                       </a>
//                     </div>
//                   ) : (
//                     <p className="no-document">No document uploaded</p>
//                   )}
//                   <div className="document-upload">
//                     <input
//                       type="file"
//                       id="latestDegree"
//                       onChange={(e) => handleFileChange(e, "latestDegree")}
//                       accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
//                     />
//                     <label htmlFor="latestDegree" className="upload-button">
//                       <FontAwesomeIcon icon={faFileUpload} />{" "}
//                       {documents?.latestDegree ? "Replace" : "Upload"}
//                     </label>
//                     {documentFiles.latestDegree && (
//                       <span className="file-name">
//                         {documentFiles.latestDegree.name}
//                       </span>
//                     )}
//                     <p
//                       style={{
//                         fontSize: "0.85rem",
//                         color: "#888",
//                         marginTop: "4px",
//                       }}
//                     >
//                       Max size: 5 MB | Formats: PDF, JPG, JPEG, PNG
//                     </p>
//                   </div>
//                 </div>

//                 {/* Driving License */}
//                 <div className="document-card">
//                   <h4>Driving License</h4>
//                   {documents?.drivingLicense ? (
//                     <div className="document-preview">
//                       <FontAwesomeIcon
//                         icon={getFileIcon(documents.drivingLicense)}
//                         size="2x"
//                       />
//                       <a
//                         href={documents.drivingLicense}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className="download-link"
//                       >
//                         <FontAwesomeIcon icon={faDownload} /> View Document
//                       </a>
//                     </div>
//                   ) : (
//                     <p className="no-document">No document uploaded</p>
//                   )}
//                   <div className="document-upload">
//                     <input
//                       type="file"
//                       id="drivingLicense"
//                       onChange={(e) => handleFileChange(e, "drivingLicense")}
//                       accept=".pdf,.jpg,.jpeg,.png"
//                     />
//                     <label htmlFor="drivingLicense" className="upload-button">
//                       <FontAwesomeIcon icon={faFileUpload} />{" "}
//                       {documents?.drivingLicense ? "Replace" : "Upload"}
//                     </label>
//                     {documentFiles.drivingLicense && (
//                       <span className="file-name">
//                         {documentFiles.drivingLicense.name}
//                       </span>
//                     )}
//                     <p
//                       style={{
//                         fontSize: "0.85rem",
//                         color: "#888",
//                         marginTop: "4px",
//                       }}
//                     >
//                       Max size: 5 MB | Formats: PDF, JPG, JPEG, PNG
//                     </p>
//                   </div>
//                 </div>

//                 {/* Previous Company Letter */}
//                 <div className="document-card">
//                   <h4>Previous Company Letter</h4>
//                   {documents?.previousCompanyLetter ? (
//                     <div className="document-preview">
//                       <FontAwesomeIcon
//                         icon={getFileIcon(documents.previousCompanyLetter)}
//                         size="2x"
//                       />
//                       <a
//                         href={documents.previousCompanyLetter}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className="download-link"
//                       >
//                         <FontAwesomeIcon icon={faDownload} /> View Document
//                       </a>
//                     </div>
//                   ) : (
//                     <p className="no-document">No document uploaded</p>
//                   )}
//                   <div className="document-upload">
//                     <input
//                       type="file"
//                       id="previousCompanyLetter"
//                       onChange={(e) =>
//                         handleFileChange(e, "previousCompanyLetter")
//                       }
//                       accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
//                     />
//                     <label
//                       htmlFor="previousCompanyLetter"
//                       className="upload-button"
//                     >
//                       <FontAwesomeIcon icon={faFileUpload} />{" "}
//                       {documents?.previousCompanyLetter ? "Replace" : "Upload"}
//                     </label>
//                     {documentFiles.previousCompanyLetter && (
//                       <span className="file-name">
//                         {documentFiles.previousCompanyLetter.name}
//                       </span>
//                     )}
//                     <p
//                       style={{
//                         fontSize: "0.85rem",
//                         color: "#888",
//                         marginTop: "4px",
//                       }}
//                     >
//                       Max size: 5 MB | Formats: PDF, JPG, JPEG, PNG
//                     </p>
//                   </div>
//                 </div>

//                 {/* Offer Letter */}
//                 <div className="document-card">
//                   <h4>Offer Letter</h4>
//                   {documents?.offerLetter ? (
//                     <div className="document-preview">
//                       <FontAwesomeIcon
//                         icon={getFileIcon(documents.offerLetter)}
//                         size="2x"
//                       />
//                       <a
//                         href={documents.offerLetter}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className="download-link"
//                       >
//                         <FontAwesomeIcon icon={faDownload} /> View Document
//                       </a>
//                     </div>
//                   ) : (
//                     <p className="no-document">No document uploaded</p>
//                   )}
//                   <div className="document-upload">
//                     <input
//                       type="file"
//                       id="offerLetter"
//                       onChange={(e) => handleFileChange(e, "offerLetter")}
//                       accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
//                     />
//                     <label htmlFor="offerLetter" className="upload-button">
//                       <FontAwesomeIcon icon={faFileUpload} />{" "}
//                       {documents?.offerLetter ? "Replace" : "Upload"}
//                     </label>
//                     {documentFiles.offerLetter && (
//                       <span className="file-name">
//                         {documentFiles.offerLetter.name}
//                       </span>
//                     )}
//                     <p
//                       style={{
//                         fontSize: "0.85rem",
//                         color: "#888",
//                         marginTop: "4px",
//                       }}
//                     >
//                       Max size: 5 MB | Formats: PDF, JPG, JPEG, PNG
//                     </p>
//                   </div>
//                 </div>
//               </div>

//               {/* Upload Button */}
//               <div className="document-actions">
//                 <button
//                   onClick={handleDocumentUpload}
//                   className="save-reset-password-button"
//                   disabled={
//                     !Object.values(documentFiles).some(
//                       (file) => file !== null
//                     ) || uploading
//                   }
//                 >
//                   {uploading ? (
//                     <>
//                       <span className="spinner-small"></span> Uploading...
//                     </>
//                   ) : (
//                     <>
//                       <FontAwesomeIcon icon={faSave} /> Save Documents
//                     </>
//                   )}
//                 </button>
//               </div>
//             </div>

//             {/* Password Reset Section */}
//             <div className="password-reset-section">
//               {!isResetting ? (
//                 <button
//                   onClick={() => setIsResetting(true)}
//                   className="reset-password-button"
//                 >
//                   <FontAwesomeIcon icon={faKey} /> Reset Password
//                 </button>
//               ) : (
//                 <div className="password-reset-form">
//                   <h3>
//                     <FontAwesomeIcon icon={faLock} /> Reset Your Password
//                   </h3>
//                   <div className="form-group">
//                     <label htmlFor="newPassword">
//                       <FontAwesomeIcon icon={faKey} /> New Password
//                     </label>
//                     <input
//                       type="password"
//                       name="newPassword"
//                       id="newPassword"
//                       value={passwordData.newPassword}
//                       onChange={handlePasswordChange}
//                       placeholder="Enter new password"
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label htmlFor="confirmPassword">
//                       <FontAwesomeIcon icon={faKey} /> Confirm Password
//                     </label>
//                     <input
//                       type="password"
//                       name="confirmPassword"
//                       id="confirmPassword"
//                       value={passwordData.confirmPassword}
//                       onChange={handlePasswordChange}
//                       placeholder="Confirm new password"
//                     />
//                   </div>
//                   {passwordError && (
//                     <div className="error-message">{passwordError}</div>
//                   )}
//                   <div className="password-hint">
//                     Password must contain:
//                     <ul>
//                       <li>At least 8 characters</li>
//                       <li>One uppercase letter (A-Z)</li>
//                       <li>One lowercase letter (a-z)</li>
//                       <li>One number (0-9)</li>
//                       <li>One special character (!@#$%^&*)</li>
//                     </ul>
//                   </div>
//                   <div className="action-buttons">
//                     <button
//                       onClick={handlePasswordReset}
//                       className="save-button"
//                     >
//                       <FontAwesomeIcon icon={faSave} /> Update Password
//                     </button>
//                     <button
//                       onClick={() => {
//                         setIsResetting(false);
//                         setPasswordError("");
//                         setPasswordData({
//                           newPassword: "",
//                           confirmPassword: "",
//                         });
//                       }}
//                       className="cancel-button"
//                     >
//                       <FontAwesomeIcon icon={faTimes} /> Cancel
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         )}
//       </div>
//     </Layout>
//   );
// };

// export default EmployeePasswordReset;







////////////////////////Rishabh version start here 



import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faEnvelope,
  faPhone,
  faBriefcase,
  faCalendarAlt,
  faKey,
  faLock,
  faSave,
  faTimes,
  faFileUpload,
  faFilePdf,
  faFileImage,
  faFileWord,
  faDownload,
  faIdCard,
} from "@fortawesome/free-solid-svg-icons";
import {
  Box,
  Paper,
  Typography,
  Button,
  Avatar,
  Grid,
  CircularProgress,
  Alert,
  Snackbar,
  TextField,
  Chip,
} from "@mui/material";
import {
  Person as PersonIcon,
  CalendarToday as CalendarTodayIcon,
  LocationOn as LocationOnIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  Work as WorkIcon,
  Settings as SettingsIcon,
  CloudUpload as CloudUploadIcon,
  CheckCircle as CheckCircleIcon,
  Description as DescriptionIcon,
} from "@mui/icons-material";
import { format } from "date-fns";
import PageContainer from "../common/PageContainer";
import PageHeader from "../common/PageHeader";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const EmployeePasswordReset = () => {
  const navigate = useNavigate();
  const [employee, setEmployee] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isResetting, setIsResetting] = useState(false);
  const [isUpdatingPassword, setIsUpdatingPassword] = useState(false);
  const [passwordData, setPasswordData] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [passwordError, setPasswordError] = useState("");
  const [resetToast, setResetToast] = useState({
    open: false,
    severity: "success",
    message: "",
  });
  const [documents, setDocuments] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [documentFiles, setDocumentFiles] = useState({
    profilePicture: null, // Add this
    idcard_pic: null, // Add ID card picture
    panCard: null,
    aadharCard: null,
    latestDegree: null,
    drivingLicense: null,
    previousCompanyLetter: null,
    offerLetter: null,
  });
  const [documentError, setDocumentError] = useState("");
  const [documentSuccess, setDocumentSuccess] = useState("");
  const [removeProfilePicture, setRemoveProfilePicture] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = sessionStorage.getItem("token");

        // Fetch employee details
        const employeeResponse = await fetch(
          `${BASE_URL}/api/employees/logineduser/myprofile`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!employeeResponse.ok) {
          throw new Error("Error fetching your details");
        }

        const employeeData = await employeeResponse.json();
        setEmployee(employeeData);

        // Fetch documents
        const documentsResponse = await fetch(
          `${BASE_URL}/api/employees/documents/getdocuments`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!documentsResponse.ok) {
          throw new Error("Error fetching documents");
        }

        // In the fetchData function inside useEffect:
        const documentsData = await documentsResponse.json();
        setDocuments({
          panCard: documentsData.documents?.panCard || "",
          aadharCard: documentsData.documents?.aadharCard || "",
          latestDegree: documentsData.documents?.latestDegree || "",
          drivingLicense: documentsData.documents?.drivingLicense || "",
          previousCompanyLetter:
            documentsData.documents?.previousCompanyLetter || "",
          offerLetter: documentsData.documents?.offerLetter || "", // Add this line
          profilePicture: documentsData.profilePicture || "",
          idcard_pic: documentsData.idcard_pic || "", // Make sure this matches your backend response
        });

        setError(null);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching data:", err);
        setEmployee(null);
        setDocuments(null);
        setError("Error fetching your details");
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validatePassword = (password) => {
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return passwordRegex.test(password);
  };

  const showResetToast = (message, severity = "success") => {
    setResetToast({
      open: true,
      severity,
      message,
    });
  };

  const handlePasswordReset = async () => {
    try {
      setPasswordError("");

      // Validate inputs
      if (!passwordData.newPassword || !passwordData.confirmPassword) {
        const validationMessage = "Both password fields are required";
        setPasswordError(validationMessage);
        showResetToast(validationMessage, "error");
        return;
      }

      if (passwordData.newPassword !== passwordData.confirmPassword) {
        const validationMessage = "Passwords do not match";
        setPasswordError(validationMessage);
        showResetToast(validationMessage, "error");
        return;
      }

      if (!validatePassword(passwordData.newPassword)) {
        const validationMessage =
          "Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character"
        setPasswordError(validationMessage);
        showResetToast(validationMessage, "error");
        return;
      }

      const token = sessionStorage.getItem("token");
      if (!token) {
        showResetToast("Session expired. Please login again.", "error");
        setTimeout(() => navigate("/login"), 1200);
        return;
      }

      setIsUpdatingPassword(true);
      const response = await fetch(
        `${BASE_URL}/api/employees/myprofile/reset-password`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            newPassword: passwordData.newPassword,
            confirmPassword: passwordData.confirmPassword,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Password reset failed");
      }

      showResetToast("Password updated successfully. Redirecting to login...", "success");
      setPasswordError("");
      setPasswordData({
        newPassword: "",
        confirmPassword: "",
      });
      setIsResetting(false);
      sessionStorage.removeItem("token");
      setTimeout(() => navigate("/login"), 1800);
    } catch (error) {
      console.error("Password reset error:", error);
      setPasswordError(error.message);
      showResetToast(error.message || "Password reset failed", "error");
    } finally {
      setIsUpdatingPassword(false);
    }
  };

  const handleFileChange = (e, documentType) => {
    const file = e.target.files[0];
    if (file) {
      if (documentType === "profilePicture") {
        setRemoveProfilePicture(false);
      }
      setDocumentFiles((prev) => ({
        ...prev,
        [documentType]: file,
      }));
    }
  };

  const handleDocumentUpload = async () => {
    try {
      const token = sessionStorage.getItem("token");
      if (!token) {
        throw new Error("Authentication token missing");
      }

      const formData = new FormData();
      let hasFiles = false;

      Object.entries(documentFiles).forEach(([key, file]) => {
        if (file) {
          if (file.size > 5 * 1024 * 1024) {
            throw new Error(`${key} file is too large (max 5MB)`);
          }

          if (key === "profilePicture" || key === "idcard_pic") {
            if (!file.type.match("image.*")) {
              throw new Error(`${key} must be an image (JPEG, PNG)`);
            }
          } else {
            const validTypes = ["application/pdf", "image/jpeg", "image/png"];
            if (!validTypes.includes(file.type)) {
              throw new Error(`${key} must be PDF, JPEG, or PNG`);
            }
          }

          formData.append(key, file);
          hasFiles = true;
        }
      });

      if (removeProfilePicture) {
        formData.append("removeProfilePicture", "true");
      }

      if (!hasFiles && !removeProfilePicture) {
        setDocumentError("Please upload a document or select remove for profile image");
        return;
      }

      setUploading(true);
      setDocumentError("");
      setDocumentSuccess("");

      const response = await fetch(
        `${BASE_URL}/api/employees/myprofile/documents`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        }
      );

      const contentType = response.headers.get("content-type");
      let responseData;

      if (contentType && contentType.includes("application/json")) {
        responseData = await response.json();
      } else {
        const text = await response.text();
        responseData = { message: text || "Unknown error occurred" };
      }

      if (!response.ok) {
        throw new Error(
          responseData.message ||
          `Document upload failed with status ${response.status}`
        );
      }

      // Update the documents state with the new URLs
      setDocuments((prev) => ({
        ...prev,
        panCard: responseData.documents?.panCard ?? prev.panCard,
        aadharCard: responseData.documents?.aadharCard ?? prev.aadharCard,
        latestDegree: responseData.documents?.latestDegree ?? prev.latestDegree,
        drivingLicense:
          responseData.documents?.drivingLicense ?? prev.drivingLicense,
        previousCompanyLetter:
          responseData.documents?.previousCompanyLetter ??
          prev.previousCompanyLetter,
        profilePicture: responseData.profilePicture ?? prev.profilePicture,
        idcard_pic: responseData.idcard_pic ?? prev.idcard_pic, // Make sure this matches your backend response
      }));

      setDocumentSuccess("Documents uploaded successfully!");
      setDocumentFiles({
        profilePicture: null,
        idcard_pic: null,
        panCard: null,
        aadharCard: null,
        latestDegree: null,
        drivingLicense: null,
        previousCompanyLetter: null,
        offerLetter: null, // Add this line
      });
      setRemoveProfilePicture(false);

      // Refresh employee data if profile picture or ID card was updated
      if (documentFiles.profilePicture || documentFiles.idcard_pic) {
        const employeeResponse = await fetch(
          `${BASE_URL}/api/employees/logineduser/myprofile`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (employeeResponse.ok) {
          const employeeData = await employeeResponse.json();
          setEmployee(employeeData);
        }
      }
    } catch (error) {
      console.error("Document upload error:", error);
      setDocumentError(
        error.message || "Failed to upload documents. Please try again."
      );
    } finally {
      setUploading(false);
      setTimeout(() => {
        setDocumentError("");
        setDocumentSuccess("");
      }, 5000);
    }
  };

  const getFileIcon = (fileName) => {
    if (!fileName) return faFileImage;
    const extension = fileName.split(".").pop().toLowerCase();
    if (["pdf"].includes(extension)) return faFilePdf;
    if (["doc", "docx"].includes(extension)) return faFileWord;
    if (["jpg", "jpeg", "png", "gif"].includes(extension)) return faFileImage;
    return faFileImage;
  };

  // Common styles
  const paperCardSx = {
    elevation: 0,
    border: "1px solid #eef0f6",
    borderRadius: "16px",
    p: 3,
    bgcolor: "#fff",
  };

  const sectionTitleSx = {
    fontWeight: 600,
    fontSize: "1rem",
    color: "#1a1a2e",
    pb: 1.5,
    mb: 2.5,
    borderBottom: "1px solid #eef0f6",
  };

  const uploadCardSx = {
    border: "2px dashed #d0d5dd",
    borderRadius: "12px",
    p: 2.5,
    textAlign: "center",
    cursor: "pointer",
    transition: "all 0.2s ease",
    "&:hover": {
      borderColor: "#667eea",
      bgcolor: "rgba(102, 126, 234, 0.02)",
    },
  };

  const gradientBtnSx = {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "#fff",
    textTransform: "none",
    fontWeight: 600,
    borderRadius: "10px",
    px: 3,
    py: 1,
    "&:hover": {
      background: "linear-gradient(135deg, #5a6fd6 0%, #6a4294 100%)",
      boxShadow: "0 4px 12px rgba(102, 126, 234, 0.4)",
    },
  };

  // Document upload card config
  const documentCards = [
    { key: "profilePicture", label: "Profile Picture", accept: ".jpg,.jpeg,.png", isImage: true, icon: faUser },
    { key: "idcard_pic", label: "ID Card Picture", accept: ".jpg,.jpeg,.png", isImage: true, icon: faIdCard },
    { key: "panCard", label: "PAN Card", accept: ".pdf,.jpg,.jpeg,.png", isImage: false, icon: faIdCard },
    { key: "aadharCard", label: "Aadhar Card", accept: ".pdf,.jpg,.jpeg,.png", isImage: false, icon: faIdCard },
    { key: "latestDegree", label: "Latest Degree", accept: ".pdf,.jpg,.jpeg,.png", isImage: false, icon: faIdCard },
    { key: "drivingLicense", label: "Driving License", accept: ".pdf,.jpg,.jpeg,.png", isImage: false, icon: faIdCard },
    { key: "previousCompanyLetter", label: "Previous Company Letter", accept: ".pdf,.jpg,.jpeg,.png", isImage: false, icon: faIdCard },
    { key: "offerLetter", label: "Offer Letter", accept: ".pdf,.jpg,.jpeg,.png", isImage: false, icon: faFileUpload },
  ];

  return (
    <PageContainer>
      {/* Page Header */}
      <PageHeader
        gradient
        title="Documents & Information"
        subtitle="Access, upload, and manage important documents and company information"
        icon={<SettingsIcon />}
      />

      {/* Alerts */}
      <Snackbar
        open={resetToast.open}
        autoHideDuration={3500}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setResetToast((prev) => ({ ...prev, open: false }))}
      >
        <Alert
          severity={resetToast.severity}
          variant="filled"
          onClose={() => setResetToast((prev) => ({ ...prev, open: false }))}
          sx={{
            width: "100%",
            minWidth: { xs: "280px", sm: "420px" },
            borderRadius: "12px",
            boxShadow: "0 10px 25px rgba(0, 0, 0, 0.18)",
            alignItems: "center",
            fontWeight: 500,
          }}
        >
          {resetToast.message}
        </Alert>
      </Snackbar>

      {error && (
        <Alert severity="error" sx={{ mb: 2, borderRadius: "12px" }} onClose={() => setError(null)}>
          {error}
        </Alert>
      )}
      {documentError && (
        <Alert severity="error" sx={{ mb: 2, borderRadius: "12px" }} onClose={() => setDocumentError("")}>
          {documentError}
        </Alert>
      )}
      {documentSuccess && (
        <Alert severity="success" sx={{ mb: 2, borderRadius: "12px" }} onClose={() => setDocumentSuccess("")}>
          {documentSuccess}
        </Alert>
      )}

      {/* Loading State */}
      {loading && (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 400 }}>
          <CircularProgress sx={{ color: "#667eea" }} />
        </Box>
      )}

      {employee && (
        <>
          {/* Profile Card */}
          <Paper
            elevation={0}
            sx={{
              border: "1px solid #eef0f6",
              borderRadius: "16px",
              p: 3,
              mb: 3,
              bgcolor: "#fff",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 3, flexWrap: { xs: "wrap", sm: "nowrap" } }}>
              {/* Gradient Avatar Ring */}
              <Box
                sx={{
                  width: 90,
                  height: 90,
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  p: "3px",
                  flexShrink: 0,
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "50%",
                    overflow: "hidden",
                    bgcolor: "#fff",
                  }}
                >
                  {documents?.profilePicture ? (
                    <Box
                      component="img"
                      src={documents.profilePicture}
                      alt="Profile"
                      sx={{ width: "100%", height: "100%", objectFit: "cover" }}
                    />
                  ) : (
                    <Box
                      sx={{
                        width: "100%",
                        height: "100%",
                        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "32px",
                        fontWeight: 700,
                        color: "#fff",
                      }}
                    >
                      {employee.name?.charAt(0).toUpperCase()}
                    </Box>
                  )}
                </Box>
              </Box>

              {/* Name, Role Badge, Employee ID */}
              <Box sx={{ flex: 1 }}>
                <Typography sx={{ fontWeight: 700, fontSize: "1.25rem", color: "#1a1a2e", mb: 0.5 }}>
                  {employee.name}
                </Typography>
                <Chip
                  label={employee.role}
                  size="small"
                  sx={{
                    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    color: "#fff",
                    fontWeight: 600,
                    fontSize: "0.75rem",
                    mb: 1,
                  }}
                />
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: { xs: 1.5, sm: 3 }, mt: 1 }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                    <FontAwesomeIcon icon={faIdCard} style={{ color: "#667eea", fontSize: 14 }} />
                    <Typography sx={{ fontSize: "0.85rem", color: "#64748B" }}>
                      {employee.employeeid}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                    <FontAwesomeIcon icon={faEnvelope} style={{ color: "#667eea", fontSize: 14 }} />
                    <Typography sx={{ fontSize: "0.85rem", color: "#64748B" }}>
                      {employee.email}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                    <FontAwesomeIcon icon={faPhone} style={{ color: "#667eea", fontSize: 14 }} />
                    <Typography sx={{ fontSize: "0.85rem", color: "#64748B" }}>
                      {employee.contactNumber}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Paper>

          {/* Two-Column Grid: Employment Details + Password Reset */}
          <Grid container spacing={3} sx={{ mb: 3 }}>
            {/* Left: Employment Details */}
            <Grid item xs={12} md={7}>
              <Paper elevation={0} sx={{ ...paperCardSx, height: "100%" }}>
                <Typography sx={sectionTitleSx}>
                  Employment Details
                </Typography>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                    gap: 2.5,
                  }}
                >
                  {[
                    { icon: <PersonIcon sx={{ color: "#667eea", fontSize: 20 }} />, label: "Name", value: employee.name },
                    { icon: <CalendarTodayIcon sx={{ color: "#667eea", fontSize: 20 }} />, label: "Date of Joining", value: format(new Date(employee.dateOfJoining), "dd-MM-yyyy") },
                    { icon: <LocationOnIcon sx={{ color: "#667eea", fontSize: 20 }} />, label: "Job Location", value: employee.jobLocation },
                    { icon: <EmailIcon sx={{ color: "#667eea", fontSize: 20 }} />, label: "Email Address", value: employee.email },
                    { icon: <PhoneIcon sx={{ color: "#667eea", fontSize: 20 }} />, label: "Phone Number", value: employee.contactNumber },
                    { icon: <WorkIcon sx={{ color: "#667eea", fontSize: 20 }} />, label: "Work Mode", value: employee.workMode },
                  ].map((item, idx) => (
                    <Box key={idx} sx={{ display: "flex", alignItems: "flex-start", gap: 1.5 }}>
                      <Box sx={{
                        width: 36, height: 36, borderRadius: "10px",
                        bgcolor: "rgba(102, 126, 234, 0.08)",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        flexShrink: 0,
                      }}>
                        {item.icon}
                      </Box>
                      <Box>
                        <Typography sx={{ fontSize: "0.8rem", color: "#8b8fa3", mb: 0.25 }}>
                          {item.label}
                        </Typography>
                        <Typography sx={{ fontSize: "0.9rem", fontWeight: 500, color: "#1a1a2e" }}>
                          {item.value}
                        </Typography>
                      </Box>
                    </Box>
                  ))}
                </Box>
              </Paper>
            </Grid>

            {/* Right: Password Reset */}
            <Grid item xs={12} md={5}>
              <Paper elevation={0} sx={{ ...paperCardSx, height: "100%" }}>
                <Typography sx={sectionTitleSx}>
                  Password Reset
                </Typography>
                {!isResetting ? (
                  <Box sx={{ textAlign: "center", py: 4 }}>
                    <Box sx={{
                      width: 64, height: 64, borderRadius: "16px",
                      background: "rgba(102, 126, 234, 0.08)",
                      display: "flex", alignItems: "center", justifyContent: "center",
                      mx: "auto", mb: 2,
                    }}>
                      <FontAwesomeIcon icon={faLock} style={{ fontSize: 24, color: "#667eea" }} />
                    </Box>
                    <Typography sx={{ fontSize: "0.9rem", color: "#64748B", mb: 2.5 }}>
                      Update your password to keep your account secure
                    </Typography>
                    <Button
                      onClick={() => setIsResetting(true)}
                      sx={gradientBtnSx}
                      startIcon={<FontAwesomeIcon icon={faKey} />}
                    >
                      Reset Password
                    </Button>
                  </Box>
                ) : (
                  <Box>
                    <TextField
                      fullWidth
                      type="password"
                      name="newPassword"
                      label="New Password"
                      value={passwordData.newPassword}
                      onChange={handlePasswordChange}
                      placeholder="Enter new password"
                      size="small"
                      sx={{ mb: 2, "& .MuiOutlinedInput-root": { borderRadius: "10px" } }}
                    />
                    <TextField
                      fullWidth
                      type="password"
                      name="confirmPassword"
                      label="Confirm Password"
                      value={passwordData.confirmPassword}
                      onChange={handlePasswordChange}
                      placeholder="Confirm new password"
                      size="small"
                      sx={{ mb: 2, "& .MuiOutlinedInput-root": { borderRadius: "10px" } }}
                    />
                    {passwordError && (
                      <Alert severity="error" sx={{ mb: 2, borderRadius: "10px", fontSize: "0.8rem" }}>
                        {passwordError}
                      </Alert>
                    )}
                    <Paper
                      elevation={0}
                      sx={{
                        bgcolor: "rgba(102, 126, 234, 0.04)",
                        border: "1px solid #eef0f6",
                        borderRadius: "10px",
                        p: 2,
                        mb: 2.5,
                      }}
                    >
                      <Typography sx={{ fontSize: "0.8rem", fontWeight: 600, color: "#1a1a2e", mb: 0.75 }}>
                        Password must contain:
                      </Typography>
                      {["At least 8 characters", "One uppercase letter (A-Z)", "One lowercase letter (a-z)", "One number (0-9)", "One special character (!@#$%^&*)"].map((rule, i) => (
                        <Typography key={i} sx={{ fontSize: "0.75rem", color: "#64748B", pl: 1.5, mb: 0.25 }}>
                          {rule}
                        </Typography>
                      ))}
                    </Paper>
                    <Box sx={{ display: "flex", gap: 1.5 }}>
                      <Button
                        onClick={handlePasswordReset}
                        disabled={isUpdatingPassword}
                        sx={gradientBtnSx}
                        startIcon={
                          isUpdatingPassword
                            ? <CircularProgress size={16} sx={{ color: "#fff" }} />
                            : <FontAwesomeIcon icon={faSave} />
                        }
                      >
                        {isUpdatingPassword ? "Updating..." : "Update Password"}
                      </Button>
                      <Button
                        variant="outlined"
                        onClick={() => {
                          setIsResetting(false);
                          setPasswordError("");
                          setPasswordData({ newPassword: "", confirmPassword: "" });
                        }}
                        sx={{
                          textTransform: "none",
                          fontWeight: 600,
                          borderRadius: "10px",
                          borderColor: "#d0d5dd",
                          color: "#64748B",
                          px: 3,
                          "&:hover": { borderColor: "#667eea", color: "#667eea" },
                        }}
                        startIcon={<FontAwesomeIcon icon={faTimes} />}
                      >
                        Cancel
                      </Button>
                    </Box>
                  </Box>
                )}
              </Paper>
            </Grid>
          </Grid>

          {/* Document Upload Section */}
          <Paper elevation={0} sx={{ ...paperCardSx, mb: 3 }}>
            <Typography sx={sectionTitleSx}>
              Document Uploads
            </Typography>

            <Grid container spacing={2.5}>
              {documentCards.map((doc) => {
                const existingDoc = documents?.[doc.key];
                const effectiveExistingDoc =
                  doc.key === "profilePicture" && removeProfilePicture
                    ? ""
                    : existingDoc;
                const selectedFile = documentFiles[doc.key];

                return (
                  <Grid item xs={12} sm={6} md={4} key={doc.key}>
                    <Box sx={uploadCardSx}>
                      {/* Icon and Title */}
                      <Box sx={{
                        width: 44, height: 44, borderRadius: "12px",
                        bgcolor: effectiveExistingDoc ? "rgba(76, 175, 80, 0.08)" : "rgba(102, 126, 234, 0.08)",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        mx: "auto", mb: 1.5,
                      }}>
                        {effectiveExistingDoc ? (
                          <CheckCircleIcon sx={{ color: "#4caf50", fontSize: 22 }} />
                        ) : (
                          <CloudUploadIcon sx={{ color: "#667eea", fontSize: 22 }} />
                        )}
                      </Box>

                      <Typography sx={{ fontWeight: 600, fontSize: "0.85rem", color: "#1a1a2e", mb: 0.5 }}>
                        {doc.label}
                      </Typography>

                      {/* Show existing document status */}
                      {effectiveExistingDoc && (
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5, mb: 1 }}>
                          <FontAwesomeIcon icon={getFileIcon(existingDoc)} style={{ color: "#4caf50", fontSize: 12 }} />
                          <Typography sx={{ fontSize: "0.7rem", color: "#4caf50", fontWeight: 500 }}>
                            Uploaded
                          </Typography>
                        </Box>
                      )}
                      {doc.key === "profilePicture" && removeProfilePicture && (
                        <Typography sx={{ fontSize: "0.72rem", color: "#DC2626", fontWeight: 600, mb: 1 }}>
                          Marked for removal
                        </Typography>
                      )}

                      {/* Selected file name */}
                      {selectedFile && (
                        <Typography sx={{ fontSize: "0.7rem", color: "#667eea", fontWeight: 500, mb: 1, wordBreak: "break-all" }}>
                          {selectedFile.name}
                        </Typography>
                      )}

                      {/* Action buttons */}
                      <Box sx={{ display: "flex", justifyContent: "center", gap: 1, mt: 1 }}>
                        <input
                          type="file"
                          id={doc.key}
                          style={{ display: "none" }}
                          onChange={(e) => handleFileChange(e, doc.key)}
                          accept={doc.accept}
                        />
                        <label htmlFor={doc.key}>
                          <Button
                            component="span"
                            size="small"
                            sx={{
                              textTransform: "none",
                              fontWeight: 600,
                              fontSize: "0.75rem",
                              borderRadius: "8px",
                              px: 2,
                              py: 0.5,
                              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                              color: "#fff",
                              "&:hover": {
                                background: "linear-gradient(135deg, #5a6fd6 0%, #6a4294 100%)",
                              },
                            }}
                          >
                            {effectiveExistingDoc ? "Replace" : "Upload"}
                          </Button>
                        </label>

                        {effectiveExistingDoc && (
                          <Button
                            href={existingDoc}
                            target="_blank"
                            rel="noopener noreferrer"
                            variant="outlined"
                            size="small"
                            sx={{
                              textTransform: "none",
                              fontWeight: 600,
                              fontSize: "0.75rem",
                              borderRadius: "8px",
                              px: 2,
                              py: 0.5,
                              borderColor: "#d0d5dd",
                              color: "#64748B",
                              "&:hover": { borderColor: "#667eea", color: "#667eea" },
                            }}
                            startIcon={<FontAwesomeIcon icon={faDownload} style={{ fontSize: 11 }} />}
                          >
                            View
                          </Button>
                        )}
                        {doc.key === "profilePicture" && effectiveExistingDoc && (
                          <Button
                            variant="outlined"
                            size="small"
                            onClick={() => {
                              setRemoveProfilePicture(true);
                              setDocumentFiles((prev) => ({
                                ...prev,
                                profilePicture: null,
                              }));
                            }}
                            sx={{
                              textTransform: "none",
                              fontWeight: 600,
                              fontSize: "0.75rem",
                              borderRadius: "8px",
                              px: 2,
                              py: 0.5,
                              borderColor: "#FCA5A5",
                              color: "#B91C1C",
                              "&:hover": { borderColor: "#DC2626", bgcolor: "#FEF2F2" },
                            }}
                          >
                            Remove
                          </Button>
                        )}
                      </Box>

                      <Typography sx={{ fontSize: "0.65rem", color: "#8b8fa3", mt: 1.5 }}>
                        Max 5 MB | {doc.isImage ? "JPG, PNG" : "PDF, JPG, PNG"}
                      </Typography>
                    </Box>
                  </Grid>
                );
              })}
            </Grid>

            {/* Save Documents Button */}
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
              <Button
                onClick={handleDocumentUpload}
                disabled={
                  (!Object.values(documentFiles).some((file) => file !== null) &&
                    !removeProfilePicture) ||
                  uploading
                }
                sx={{
                  ...gradientBtnSx,
                  px: 4,
                  py: 1.2,
                  "&.Mui-disabled": {
                    background: "#e0e0e0",
                    color: "#9e9e9e",
                  },
                }}
                startIcon={
                  uploading ? (
                    <CircularProgress size={18} sx={{ color: "white" }} />
                  ) : (
                    <FontAwesomeIcon icon={faSave} />
                  )
                }
              >
                {uploading ? "Uploading..." : "Save Documents"}
              </Button>
            </Box>
          </Paper>
        </>
      )}
    </PageContainer>
  );
};

export default EmployeePasswordReset;
